import { GuestType } from '@camp67/model';
import React from 'react';

interface NumberFieldProps {
  type: GuestType;
  label: string;
  isRequired?: boolean;
  detail?: string;
  value: number;
  onChange: (chosen: number) => void;
  name: string;
}

export const NumberField: React.FC<NumberFieldProps> = ({
  isRequired = false,
  label,
  detail,
  value,
  onChange,
  name,
}) => {
  return (
    <div className="w-full flex flex-col gap-2 mt-5" id={`${name}-field`}>
      <div className="w-full py-3 px-5 flex flex-col bg-gray-100 rounded-md relative border-2 border-transparent focus-within:border-2 focus-within:border-blue-950">
        <label className="font-sans text-gray-250 font-regular text-sm">
          {label}
          {isRequired && '*'}
        </label>
        <input
          type="number"
          className="outline-none text-base md:text-base border-none w-full pt-1.5 m-0 bg-gray-100"
          value={value}
          onChange={(evt) => onChange(parseInt(evt.target.value))}
          required={isRequired}
          name={name}
          id={`${name}-field`}
          min={0}
          onWheelCapture={(e) => {
            e.currentTarget.blur();
          }}
        />
      </div>
      {detail ? <span className="text-right text-xs text-gray-500">{detail}</span> : null}
    </div>
  );
};
